import { call } from 'redux-saga/effects';
import * as Api from '../../../services/fbm-api';
import * as routines from './routines';
import { sagaRoutineRequest } from '../../../helpers/saga';

export const fetchHouseholdMemberColumns = () =>
  sagaRoutineRequest(routines.fetchHouseholdMemberColumns, {
    request: () => call(Api.fetchHouseholdMemberColumns)
  });
